// Re-export shim for backwards compatibility. New code should import from
// @/config/deployment directly. This file is kept so existing
// `@/localeConfig` imports across the codebase continue to resolve.
export type { IDeployParams } from '@/config/deployment';
export {
  localeConfig,
  localeProductionConfig,
  localeStagingSSRConfig,
  localeDevelopmentConfig,
  localeLocalConfig,
} from '@/config/deployment';
